import { useMutation } from '@tanstack/react-query';
import { log } from 'evlog/client';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { z } from 'zod';

import { CardContent, Input, Label } from '@virtual-care/shadcn';
import { AuthLayout, TheButton, resetPasswordViaEmail } from '@virtual-care/ui';

import { auth } from '../firebase.tsx';

export default function B2BForgotPassword() {
  const [email, setEmail] = useState('');
  const { t } = useTranslation();
  const mutation = useMutation({
    mutationKey: ['reset-password'],
    mutationFn: async () => {
      log.info({ action: 'b2b_forgot_password' });
      if (z.string().email().safeParse(email).success) {
        await resetPasswordViaEmail(auth, email, '/b2b-reset-password');
      } else {
        throw new Error('shared.validation.emailInvalid');
      }
    },
  });

  return (
    <AuthLayout
      center
      title={t('auth.b2bForgotPassword.title')}
      subtitle={t('auth.b2bForgotPassword.subtitle')}
    >
      <CardContent className="space-y-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="email" className="text-sm font-medium">
            {t('auth.common.email')}
          </Label>
          <Input
            id="email"
            dir="ltr"
            type="email"
            autoComplete="email"
            placeholder={t('auth.common.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
          />
        </div>
        <TheButton
          type="button"
          onClick={() => mutation.mutate()}
          loading={mutation.isPending}
          disabled={!email}
          icon={<ArrowLeft className="h-4 w-4 rtl:rotate-180" />}
          className="w-full"
        >
          {t('auth.b2bForgotPassword.submit')}
        </TheButton>
        {mutation.error && (
          <p className="text-sm text-red-500">
            {t((mutation.error as Error).message)}
          </p>
        )}
        {mutation.isSuccess && (
          <p className="text-sm text-green-500">
            {t('auth.b2bForgotPassword.success')}
          </p>
        )}
        <div className="flex flex-col space-y-4">
          <Link to="/b2b-login" className="text-muted-foreground text-sm">
            {t('auth.b2bForgotPassword.haveAccount')}
            <span className="text-foreground mx-1">
              {t('auth.common.signin')}
            </span>
          </Link>
        </div>
      </CardContent>
    </AuthLayout>
  );
}
